import styled from 'styled-components'
import { theme } from '@/client/components'
const { breakpoint } = theme

export const BreadcrumbStyles = styled.div`
  display: flex;
  position: relative;
  top: -5rem;
`

export const FeaturedStyles = styled.div<{ imageUrl: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(p) => (p.imageUrl ? `url(${p.imageUrl})` : '#000000')};
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 600px;
  position: relative;
  top: -4.5rem;

  @media (min-width: ${breakpoint.xl}) {
    height: 700px;
  }
`

export const TextWrapper = styled.div`
  width: 100%;

  @media (min-width: ${breakpoint.xl}) {
    width: 60%;
  }
`

export const TextAligner = styled.div`
  width: 55%;
  position: relative;

  @media (min-width: ${breakpoint.xs2}) {
    top: 1.5em;
  }

  @media (min-width: ${breakpoint.sm}) {
    top: 2.3rem;
  }

  @media (min-width: ${breakpoint.lg}) {
    top: 1.5rem;
  }
  @media (min-width: ${breakpoint.xl}) {
    top: 0.5rem;
  }

  @media (min-width: ${breakpoint.xl2}) {
    top: 1rem;
    left: 2rem;
  }

  @media (min-width: ${breakpoint.hd}) {
    width: 100%;
    position: relative;
    top: 1.2rem;
    left: 3rem;
  }
`
